import React, { useState, cloneElement } from "react";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import { Slide } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import SectionHeader from "../../../../components/UI/SectionHeader";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  paper: {
    width: "100%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  dialogContent: {
    maxHeight: 300,
  },
});

const PasRequestAlert = (props) => {
  const [open, setOpen] = useState(false);

  const { classes, dialogAnchorComponent, repCode, requestPasRepCode } = props;
  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleRequestPershing = () => {
    setOpen(false);
    requestPasRepCode(repCode);
  };

  return (
    <React.Fragment>
      {cloneElement(dialogAnchorComponent, { onClick: handleOpenModal })}
      <Dialog
        open={open}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={handleCloseModal}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        aria-labelledby="notification-modal-title"
        maxWidth={"sm"}
        scroll={"paper"}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle id="notification-modal-title" disableTypography>
          <SectionHeader text={"Confirm"} />
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant={"subtitle1"}>
            Will you be using Pershing as a Custodian?
          </Typography>
          <Typography variant={"body1"}>
            A PAS Rep Code is only required if you are using Pershing as
            Custodian.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleRequestPershing}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseModal}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default withStyles(styles)(PasRequestAlert);



// WEBPACK FOOTER //
// ./src/containers/UserRepCodes/components/PasRepCodeNotification/index.js